"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import DistributionDialog from "@/components/dialog/DistributionDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
import _ from "lodash";
let ShopOnlyChooseUsers = class extends Vue {
  constructor() {
    super(...arguments);
    this.activeName = "first";
    this.selectDatas = [];
    this.shopId = null;
    this.selectLock = false;
    this.searchStr = "";
    this.rows = [];
    this.gridController = new GridController(new APIDataSource("api://base.auth/api/v7/users"));
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.filter = `userStatus=='0';name=='%${searchStr}%',account=='%${searchStr}%'`;
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.filter = `userStatus=='0'`;
      }
      this.gridController.query.current = 1;
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.pagePosition = "dialog";
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.size = true;
    this.gridController.query.filter = `userStatus=='0'`;
  }
  open(selectDatas, shop_id, vd_id) {
    let arr = [];
    this.gridController.query.params = null;
    if (shop_id) {
      this.gridController.query.params = {
        search: `shopGuid=in=(${shop_id})`
      };
    }
    if (vd_id) {
      this.gridController.query.params = {
        search: `vdGuid=in=(${vd_id})`
      };
    }
    this.gridController.search();
    this._distributionDialog.open();
    this.$nextTick(() => {
      console.log(selectDatas);
      if (selectDatas && selectDatas.length > 0) {
        for (const item of selectDatas) {
          this._distributionDialog.add(item);
        }
      }
    });
  }
  saved(data) {
    return __async(this, null, function* () {
      this.$emit("saveUsers", data);
      this._distributionDialog.close();
    });
  }
  selectable(row, index) {
    let _data = this._distributionDialog.getAllNew();
    if (_data.length > 0) {
      for (const item of _data) {
        if (item.id === row.id) {
          return true;
        }
      }
      return false;
    }
    if (_data.length === 0) {
      return true;
    }
    return false;
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      if (items.length > 1) {
        this.$message.error(
          this.$t("shopbindadmin.show_error_message")
        );
        return;
      }
      if (this._distributionDialog.getAll().length >= 1 && items.length !== 0 && items.length > 1) {
        this.$message.error(
          this.$t("shopbindadmin.show_error_message")
        );
        return;
      }
      let unSelectData = _.differenceWith(this.gridController.result.datas, items, _.isEqual);
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._distributionDialog.del(_item);
      }
    }
  }
  changed(data) {
    let rows = _.differenceWith(this.selectDatas, data, (selectData, data2) => selectData.guid == data2.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, false);
      }
    }
    this.selectLock = false;
  }
  checkItem() {
    let selectDatas = this._distributionDialog.getAll();
    let rows = _.intersectionWith(this.gridController.result.datas, selectDatas, (selectData, data) => selectData.guid == data.id);
    this.selectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.selectLock = false;
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
  refresh() {
    this.searchStr = "";
    this.gridController.query.filter = `userStatus=='0'`;
    this.gridController.query.current = 1;
  }
};
__decorateClass([
  Ref("distributionDialog")
], ShopOnlyChooseUsers.prototype, "_distributionDialog", 2);
__decorateClass([
  Ref("multipleTable")
], ShopOnlyChooseUsers.prototype, "_multipleTable", 2);
ShopOnlyChooseUsers = __decorateClass([
  Component({
    components: {
      DistributionDialog,
      UiGrid
    }
  })
], ShopOnlyChooseUsers);
export {
  ShopOnlyChooseUsers as default
};
